import React, { useState, useEffect } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './Hero.css';
import hero1 from '../../assets/carousel1.jpeg';
import hero2 from '../../assets/carousel2.jpeg';
import hero3 from '../../assets/carousel3.jpeg';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: "Solutions Digitales Sur Mesure",
      subtitle: "Nous transformons vos idées en réalités numériques",
      btnText: "Découvrir nos services",
      image: hero1
    },
    {
      title: "Innovation Technologique",
      subtitle: "Des solutions avancées pour votre croissance digitale",
      btnText: "Découvrir nos services",
      image: hero2
    },
    {
      title: "Excellence Créative",
      subtitle: "Design et fonctionnalité au service de votre marque",
      btnText: "Découvrir nos services",
      image: hero3
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  return (
    <section id="home" className="hero">
      <div className="carousel-container">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${slide.image})` }}
          >
            <div className="carousel-content">
              <h1 className="hero-title">{slide.title}</h1>
              <p className="hero-subtitle">{slide.subtitle}</p>
              <a href="#services" className="btn">{slide.btnText}</a>
            </div>
          </div>
        ))}

        <button className="carousel-control prev" onClick={prevSlide} aria-label="Précédent">
          <FaChevronLeft />
        </button>

        <button className="carousel-control next" onClick={nextSlide} aria-label="Suivant">
          <FaChevronRight />
        </button>

        <div className="carousel-indicators">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`indicator ${index === currentSlide ? 'active' : ''}`}
              onClick={() => setCurrentSlide(index)}
              aria-label={`Aller au slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;